import type { createStore } from "jotai";
import type { IJWTUserPayload } from "../../../interfaces/JWTUserPayload";
import { globalStore } from "../../../../stores/global.store";
import { accessTokenAtom } from "../stores/access-token/access-token.store";
import type { IAuthStateService } from "./auth-state.service.interface";
import { isTokenValid } from "./is-token-valid";

type JotaiStore = ReturnType<typeof createStore>;

export class AuthStateService implements IAuthStateService {
  constructor(private readonly _store: JotaiStore = globalStore) {}

  getAccessToken(): IJWTUserPayload | undefined {
    return this._store.get(accessTokenAtom);
  }

  setAccessToken(token: IJWTUserPayload): void {
    this._store.set(accessTokenAtom, token);
  }

  resetAccessToken(): void {
    this._store.set(accessTokenAtom, undefined);
  }

  isAuthenticated(): boolean {
    return isTokenValid(this.getAccessToken());
  }
}
